import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css'; // Or App.css if it's your main entry
import App from './App';
import reportWebVitals from './reportWebVitals';
import { AuthProvider } from './context/AuthContext'; // <--- 1. IMPORT AuthProvider

import posthog from 'posthog-js'
import { PostHogProvider } from 'posthog-js/react'

// Initialize PostHog
posthog.init(process.env.REACT_APP_PUBLIC_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_PUBLIC_POSTHOG_HOST,
  session_recording: {
    recordCrossOriginIframes: false,
  },
  persistence: 'localStorage+cookie',
  capture_pageview: true,
})

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <PostHogProvider client={posthog}>
    {/* <--- 2. WRAP App with AuthProvider ---> */}
    <AuthProvider>
      <App />
    </AuthProvider>
    {/* <-------------------------------------> */}
    </PostHogProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();